/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getLabTestCategories } from 'app/entities/lab-test-category/lab-test-category.reducer';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-category-item.reducer';

export const LabTestCategoryItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const labTestCategories = useAppSelector(state => state.labTestCategory.entities);
  const labTestCategoryItemEntity = useAppSelector(state => state.labTestCategoryItem.entity);
  const loading = useAppSelector(state => state.labTestCategoryItem.loading);
  const updating = useAppSelector(state => state.labTestCategoryItem.updating);
  const updateSuccess = useAppSelector(state => state.labTestCategoryItem.updateSuccess);

  const handleClose = () => {
    navigate(`/lab-test-category-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLabTestItems({}));
    dispatch(getLabTestCategories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...labTestCategoryItemEntity,
      ...values,
      lcTestItem: labTestItems.find(it => it.id.toString() === values.lcTestItem?.toString()),
      lcTestCategory: labTestCategories.find(it => it.id.toString() === values.lcTestCategory?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...labTestCategoryItemEntity,
          lcTestItem: labTestCategoryItemEntity?.lcTestItem?.id,
          lcTestCategory: labTestCategoryItemEntity?.lcTestCategory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labTestCategoryItem.home.createOrEditLabel" data-cy="LabTestCategoryItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.home.createOrEditLabel">
              Create or edit a LabTestCategoryItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-category-item-id"
                  label={translate('tinyMedicRestApp.labTestCategoryItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestCategoryItem.active')}
                id="lab-test-category-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestCategoryItem.lastupdated')}
                id="lab-test-category-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestCategoryItem.microSec')}
                id="lab-test-category-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestCategoryItem.timestampentry')}
                id="lab-test-category-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestCategoryItem.cursor')}
                id="lab-test-category-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="lab-test-category-item-lcTestItem"
                name="lcTestItem"
                data-cy="lcTestItem"
                label={translate('tinyMedicRestApp.labTestCategoryItem.lcTestItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-category-item-lcTestCategory"
                name="lcTestCategory"
                data-cy="lcTestCategory"
                label={translate('tinyMedicRestApp.labTestCategoryItem.lcTestCategory')}
                type="select"
              >
                <option value="" key="0" />
                {labTestCategories
                  ? labTestCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-test-category-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestCategoryItemUpdate;
